import { apiGet } from '../util/HttpApi';
import { LOGIN_URL, MAIN_URL_WITH_SLASH } from './GlobalManager';

export const FREE_ACCOUNT = 'Free';
export const FREE_ACCOUNT_SUB_TYPE = 'OsmAnd Start';
export const INIT_LOGIN_STATE = 'INIT';
// REACT_APP_SKIP_LOGIN=yes (local debug only): every feature behind the login works without an account
export const SKIP_LOGIN = process.env.REACT_APP_SKIP_LOGIN === 'yes';
export const SKIP_LOGIN_USER = 'debug@localhost';
export const ERROR_EMAIL = 'error_email';
export const ERROR_PASSWORD = 'error_password';
export const ERROR_TOKEN = 'error_token';
export const EMPTY_INPUT = '';
export const LOGIN_LINK_PARAM = 'link';
export const CANCEL_LOGIN_LINK_PARAM = 'cancel-link';
export const LOGIN_LINK_EMAIL_PARAM = 'email';
export const LOGIN_REDIRECT_PARAM = 'redirect';

export async function getAccountInfo(setAccountInfo) {
    const resp = await apiGet(`${process.env.REACT_APP_USER_API_SITE}/mapapi/get-account-info`);
    if (resp.data?.info) {
        setAccountInfo(resp.data.info);
        return resp.data.info;
    }
}

// login link created by support in order-mgmt: ?email=...&link=...
export function getLoginLink(search) {
    const params = new URLSearchParams(search);
    const token = params.get(LOGIN_LINK_PARAM);
    const email = params.get(LOGIN_LINK_EMAIL_PARAM);

    return token && email ? { token, email } : null;
}

// page to open after login (?redirect=...), this site only
export function getLoginRedirect(search) {
    const to = new URLSearchParams(search).get(LOGIN_REDIRECT_PARAM);
    if (!to) {
        return null;
    }
    try {
        const url = new URL(to, globalThis.location.origin);
        return url.origin === globalThis.location.origin ? url.href : null;
    } catch {
        return null;
    }
}

function getSearchWithoutLoginLink() {
    const params = new URLSearchParams(window.location.search);
    if (params.has(LOGIN_LINK_PARAM)) {
        params.delete(LOGIN_LINK_PARAM);
        params.delete(LOGIN_LINK_EMAIL_PARAM);
    }
    const search = params.toString();

    return search ? `?${search}` : '';
}

// saves the page the login was opened from, to return there after login
function savePrevPageUrl(ctx) {
    const { pathname, search, hash } = globalThis.location;
    if (pathname.startsWith(MAIN_URL_WITH_SLASH + LOGIN_URL)) {
        return; // already on the login page, keep the stored source page
    }
    ctx.setPrevPageUrl({ url: { pathname, search, hash }, active: false });
}

export function openLoginMenu({ ctx, ltx, navigate, location }) {
    savePrevPageUrl(ctx);
    ctx.setOpenNavigationSettings(false);
    navigate({
        pathname: MAIN_URL_WITH_SLASH + LOGIN_URL,
        search: location.search,
        hash: location.hash,
    });
    ltx.setOpenLoginMenu(true);
}

export function closeLoginMenu(ltx) {
    ltx.setOpenLoginMenu(false);
    ltx.setLoginState({ default: true });
    ltx.setLoginError(null);
}

export const openLogin = ({ ctx, ltx, navigate, reopenLoginDialog = null }) => {
    if (reopenLoginDialog) {
        reopenLoginDialog();
        return;
    }
    savePrevPageUrl(ctx);
    navigate(MAIN_URL_WITH_SLASH + LOGIN_URL + getSearchWithoutLoginLink() + window.location.hash);
    ltx.setLoginState({ login: true });
};

export function createAccount({ ctx, ltx, navigate }) {
    savePrevPageUrl(ctx);
    navigate(MAIN_URL_WITH_SLASH + LOGIN_URL + window.location.search + window.location.hash);
    ltx.setLoginState({ create: true });
}
